import React from 'react';

import errorSrc from 'images/error.svg';
import noContentSrc from 'images/no_content.svg';
import BlankSlate from 'components/shared/index/blankslate';
import { Spinner } from 'ui';
import Row from './row';

const ArchivesTableBody = ({
  archivables = [],
  type,
  loading,
  error,
  selectedArchivables,
  toggleArchivable,
  bulkActionStatus,
  canUnarchive,
}) => {
  if (loading) {
    return (
      <div className="d-f jc-c ai-c py-16">
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="ContentLibrary--blankslate">
        <BlankSlate
          image={errorSrc}
          title={t('contents.library.element_library.error.title')}
          description={t('contents.library.element_library.error.description')}
        />
      </div>
    );
  }

  if (!archivables.length) {
    return (
      <div className="ContentLibrary--blankslate">
        <BlankSlate
          image={noContentSrc}
          title={t('archive.no_content.title')}
          description={t('archive.no_content.description')}
        />
      </div>
    );
  }

  return (
    <div className="Table-body">
      {archivables.map((archivable, i) => (
        <Row
          key={`$${archivable.id}`}
          index={i}
          canUnarchive={canUnarchive}
          archivable={archivable}
          type={type}
          selectedArchivables={selectedArchivables}
          toggleArchivable={toggleArchivable}
          bulkActionStatus={bulkActionStatus}
        />
      ))}
    </div>
  );
};

export default ArchivesTableBody;
